import styled from 'styled-components';

export const Button = styled.button`
  width: ${(props) => `${props.Width}`};
  margin: ${(props) => `${props.Margin}`};
  font-size: 20px;
  background: linear-gradient(0.25turn, var(--primary-color), var(--primary-color), #ef4c14);
  border: none;
  border-radius: 9px;
  background: #2c3e50;
  color: rgb(255, 255, 255);
  padding: 5px;
  font-weight: 500;
  cursor: pointer;

  @media (max-width: 1366px) {
    width: 160px;
    font-size: 16px;
  }
`;
